export default "__VITE_ASSET__9hpfyEfH__"